<template>
  <div id="projectMaintenance">
		<el-collapse v-model="activeNames">
			<el-collapse-item title="Project Extension" name="1">
				<el-form :model="delayForm" ref="delayForm" label-width="205px" style="width: 560px" v-if="delayShow">
					<el-form-item label="Start Date:" prop="startTime">
						<el-date-picker
							v-model="delayForm.startTime"
							type="date"
							value-format="yyyy-MM-dd"
							placeholder="Please select"
							:disabled="true"
						>
						</el-date-picker>
					</el-form-item>
					<el-form-item label="End Date:" prop="endTime">
						<el-date-picker
							v-model="delayForm.endTime"
							type="date"
							value-format="yyyy-MM-dd"
							placeholder="Please select"
							:disabled="true"
						>
						</el-date-picker>
					</el-form-item>
					<el-form-item label="Updated End Date:" prop="newEndTime" :rules="[{ required: true, message: 'Please select' }]">
						<el-date-picker
							v-model="delayForm.newEndTime"
							type="date"
							value-format="yyyy-MM-dd"
							placeholder="Please select"
							:picker-options="{ disabledDate }"
						>
						</el-date-picker>
					</el-form-item>
					<el-form-item label="Project Extension Reason:" prop="reason" :rules="[{ required: true, message: 'Please input' }]">
						<el-input type="textarea" clearable :autosize="{ minRows: 3, maxRows: 15}" v-model="delayForm.reason" maxlength="255" placeholder="Please input" />
					</el-form-item>
					<div style="text-align: right">
						<el-button type="primary" size="small" :loading="delayLoading" @click="confirmDelay">Confirm</el-button>
					</div>
				</el-form>
				<p class="processword" v-else>Application approval in progress.</p>
			</el-collapse-item>
			<el-collapse-item title="Project Frozen" name="2" v-if="allData && allData.projectStatus !== 6 ">
				<el-form :model="freezeForm" ref="freezeForm" label-width="205px" style="width: 560px" v-if="freezeShow">
					<el-form-item label="Project Freeze Date:" prop="stopWorkTime" :rules="[{ required: true, message: 'Please select' }]">
						<el-date-picker
							v-model="freezeForm.stopWorkTime"
							type="date"
							value-format="yyyy-MM-dd"
							placeholder="Please select"
						>
						</el-date-picker>
					</el-form-item>
					<el-form-item label="Project Freeze Reason:" prop="reason" :rules="[{ required: true, message: 'Please input' }]">
						<el-input type="textarea" v-model="freezeForm.reason" clearable :autosize="{ minRows: 3, maxRows: 15}" maxlength="255" placeholder="Please input" />
					</el-form-item>
					<el-form-item label="Estimated Resumption Date:" prop="expectedResumptionTime" :rules="[{ required: true, message: 'Please select' }]">
						<el-date-picker
							v-model="freezeForm.expectedResumptionTime"
							type="date"
							value-format="yyyy-MM-dd"
							placeholder="Please select"
						>
						</el-date-picker>
					</el-form-item>
					<div style="text-align: right">
						<el-button type="primary" size="small" :loading="freezeLoading" @click="confirmFreeze">Confirm</el-button>
					</div>
				</el-form>
				<p class="processword" v-else>Application approval in progress.</p>
			</el-collapse-item>
			<el-collapse-item title="Project Restart" name="3" v-if="allData && allData.projectStatus === 6 ">
				<div style="padding-bottom: 20px" v-if="restartShow">
					<el-button type="primary" size="small"  @click="confirmReStart">Project Restart</el-button>
				</div>
				<p class="processword" v-else>Application approval in progress.</p>
			</el-collapse-item>
			<el-collapse-item title="Change Key Person" name="4">
				<el-form :model="keyPersonnelForm" ref="keyPersonnelForm" label-width="205px" style="width: 560px">
					<el-form-item label="Change Role:" prop="role" :rules="[{ required: true, message: 'Please select' }]">
						<el-select clearable v-model="keyPersonnelForm.role" placeholder="Please select">
							<el-option
								v-for="item in roleChangeType"
								:key="item.labelKey"
								:label="item.labelValue"
								:value="item.labelKey"
							>
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="Change Person:" prop="memberNoAfterChange" :rules="[{ required: true, message: 'Please input' }]" v-if="!(keyPersonnelForm.role === 1 || keyPersonnelForm.role === 2)">
						<el-select
							v-model="keyPersonnelForm.memberNoAfterChange"
							clearable
							filterable
							remote
							placeholder="Please input"
							:remote-method="value => remoteMethod('keyPersonnelList', value)"
							@change="value => changeUser('keyPersonnelList', value)"
						>
							<el-option v-for="(item, index) in keyPersonnelList" :key="index" :label="item.empName + ' ' + item.empCode" :value="item.empCode"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="Change Person:" prop="memberNoAfterChange" :rules="[{ required: true, message: 'Please input' }]" v-if="keyPersonnelForm.role === 1 || keyPersonnelForm.role === 2">
						<el-select
							v-model="keyPersonnelForm.memberNoAfterChange"
							clearable
							filterable
							remote
							placeholder="Please input"
							:remote-method="value => searchManager('projectManagerList', value)"
							@change="value => changeUser('projectManagerList', value)"
						>
							<el-option v-for="(item, index) in projectManagerList.slice(0, 10)" :key="index" :label="item.empName + ' ' + item.empCode" :value="item.empCode"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="Reason of Change:" prop="reason" :rules="[{ required: true, message: 'Please input' }]">
						<el-input type="textarea" v-model="keyPersonnelForm.reason" clearable :autosize="{ minRows: 3, maxRows: 15}" maxlength="255" placeholder="Please input" />
					</el-form-item>
					<el-form-item class="longlable" label="Major project key person work handover approval email:" prop="file" :rules="[{ required: true, message: 'Please upload', trigger: 'change' }]">
						<el-upload
							class="upload-demo"
							action="#"
							:http-request="changeFile"
							:file-list="fileList"
							:show-file-list="false"
							:before-upload="beforeUpload"
							:limit="1"
							:on-exceed="handleExceed"
							v-model="keyPersonnelForm.file"
						>
							<el-button size="small" type="primary">Upload</el-button>
						</el-upload>
						<div class="el-upload-newlist">
							<div v-for="(item, index) in fileList" :key="index" class="el-upload-file-box">
								<a class="file-name" @click="handlePreview(item)"><i class="el-icon-document" />{{ item.name }}</a>
								<label>
									<span class="percentage" v-if="item.uploadPercentage > 0 && item.uploadPercentage < 100">{{ item.uploadPercentage }}%</span>
									<i class="el-icon-circle-check icon-check" style="color: #67c23a" v-if="item.id || item.uploadPercentage === 100"></i>
									<i class="el-icon-close icon-close" style="display: none" @click="handleRemove"></i>
								</label>
								<el-progress v-if="item.uploadPercentage > 0 && item.uploadPercentage < 100" :show-text="false" :stroke-width="2" :percentage="item.uploadPercentage"></el-progress>
							</div>
						</div>
					</el-form-item>
					<div style="text-align: right">
						<el-button type="primary" size="small" :loading="keyPersonnelLoading" @click="confirmKeyPersonnel">Confirm</el-button>
					</div>
				</el-form>
			</el-collapse-item>
		</el-collapse>
  </div>
</template>
<script>
  import moment from 'moment';
	import axios from 'axios'
  export default {
    name: 'projectMaintenance',
		components: {
		},
		props: {
			id: {
        type: Number,
        default: null,
      },
			allData: {
				type: Object,
        default: {},
			},
			projectManagerAllList: {
				type: Array,
        default: [],
			}
		},
		watch: {
			projectManagerAllList(newValue, oldValue) {
				this.projectManagerList = newValue;
			}
		},
    created () {
			// this.getUserList();
			this.getSelectInfo();
			this.getStatus(2);
			this.getStatus(3);
			this.getStatus(4);
    },
    data () {
      return {
				activeNames: ['1', '2', '3', '4'],
				delayForm: {},
				freezeForm: {},
				keyPersonnelForm: {},
				roleChangeType: [],
				keyPersonnelList: [],
				fileList: [],
				projectManagerList: [],
				delayLoading: false,
				freezeLoading: false,
				keyPersonnelLoading: false,
				delayShow: true,
				freezeShow: true,
				restartShow: true,
				cancelUpload: null,
      }
    },
    methods: {
			getStatus(type) {
				let url =`${this.$store.state.islhurl}majorProjectFlow/statusCheck?majorProjectId=${this.id}&&flowType=${type}`;
				let params = {
					islhToken : sessionStorage.getItem('islhtoken'),
				}
				this._post(url, params).then(
					res => {
						if(res.code === 200) {
							if(type === 2) this.delayShow = false;
							if(type === 3) this.freezeShow = false;
							if(type === 4) this.restartShow = false;
						}
					}
				)
			},
			disabledDate(time) {
				return time.getTime() < new Date(this.delayForm.endTime).getTime();
			},
			getSelectInfo() {
				let url = `${this.$store.state.islhurl}configMain/queryLabelList?`;
				let configKeyList = [
					'roleChangeType',
				]
				let str = '';
				configKeyList.forEach(item => {
					str += `&configKeyList=${item}`;
				})
				url = url + str.substring(1)
				const _this = this
				this._post(url).then(
					res => {
						if (res.data && res.code === 200) {
							Object.keys(res.data).forEach(function(key) {
								_this[key] = res.data[key];
							});
						}
					}
				)
			},
			remoteMethod(list, query) {
				if (query !== '') {
					// 清除之前的定时器
					if (this.timeout) {
						clearTimeout(this.timeout)
					}
					// 防抖处理，300ms后执行
					this.timeout = setTimeout(() => {
						this.fetchUserOptions(list, query)
					}, 200)
				} else {
					this[list] = []
				}
			},
			fetchUserOptions(list, query) {
				let url =`${this.$store.state.islhurl}user/select-option?keyword=${query}`;
				this._get(url).then().then(res => {
					if(res.code === 200 && res.data) {
						this[list] = res.data;
					} else {
						this[list] = [];
					}
				}).catch(error => {
					this[list] = [];
					console.error('搜索失败:', error)
				})
			},
			searchManager(list, query) {
				if (query !== '') {
					const filterTimeout = setTimeout(() => {
						this[list] = this.projectManagerAllList.filter(item => {
							return item.empCode.toLowerCase().indexOf(query.toLowerCase()) > -1 || item.empName.toLowerCase().indexOf(query.toLowerCase()) > -1;
						});
						clearTimeout(filterTimeout);
					}, 200);
				} else {
					this[list] = [];
				}
			},
			changeUser(list, values) {
				let userInfo = this[list].find(item=> item.empCode === values);
				this.keyPersonnelForm.memberNameAfterChange = userInfo.empName;
			},
			beforeUpload(file) {
        const isLt2M = file.size / 1024 / 1024 < 200;
        if (!isLt2M) {
          this.$message.error('File cannot be larger than 200MB!');
          return false;
        }
      },
			changeFile(row) {
				const file = row.file;
				let fd = new FormData();
				fd.append('file', file);
				let params = {
					islhToken: sessionStorage.getItem("islhtoken"),
				}
				fd.append('fileParam', new Blob([JSON.stringify(params)], {type: 'application/json'}));
				let url = `${this.$store.state.islhurl}s3/upload`
				// 创建 CancelToken
				const CancelToken = axios.CancelToken;
				const source = CancelToken.source();
				this.cancelUpload = source.cancel; // 存储取消函数
				this._post(url, fd, {
					cancelToken: source.token, // 绑定 CancelToken
					onUploadProgress: (percent) => {
						this.fileList = [{
							name: file.name,
							uid: file.uid,
							uploadPercentage: percent === 100 ? 99 : percent,
						}];
						// 通知Upload组件内部进度更新
					},
					noProgress: true // 禁用全局NProgress
				}).then(res => {
					if(res.code == 200) {
						this.fileList = [{
							...file,
							name: file.name,
							uid: file.uid,
							id: res.data.id,
							fileId: res.data.id,
							uploadPercentage: 100,
						}];
						this.keyPersonnelForm = {
							...this.keyPersonnelForm,
							file: file
						};
					} else {
						this.fileList = [];
						this.$message.error(res.message || 'Failed!' );
					}
				}).catch(error => {
					console.log(error)
					this.fileList = [];
				})
      },
      handleExceed() {
        this.$message.warning('Only one file is allowed for upload.');
      },
			handlePreview(file) {
				if(file.url) {
					window.open(file.url)
				}
			},
			handleRemove() {
				if (typeof this.cancelUpload === 'function') {
					this.cancelUpload('User canceled upload');
					this.cancelUpload = null;
				}
				this.fileList = [];
				this.keyPersonnelForm = {
					...this.keyPersonnelForm,
					file: []
				};
				this.fileList = []
			},
			confirmDelay() {
				this.$refs.delayForm.validate((valid) => {
					if (valid) {
						let params = {
							majorProjectId: this.id,
							newEndTime: this.delayForm.newEndTime ? moment(this.delayForm.newEndTime).format('YYYY-MM-DD HH:mm:ss') : '',
							reason: this.delayForm.reason,
							islhToken : sessionStorage.getItem('islhtoken'),
							eosToken : sessionStorage.getItem('eostoken'),
						}
						let url =`${this.$store.state.islhurl}majorProject/delay`;
						this.delayLoading = true;
						this._post(url, params).then(
							res => {
								if(res.code === 200) {
									this.$Message.success('Confirm successful!' );
									this.delayForm.endTime = this.delayForm.newEndTime;
									this.delayForm.newEndTime = '';
									this.delayForm.reason = '';
									this.$nextTick(() => {
										this.$refs.delayForm.clearValidate();
									});
									this.getStatus(2);
								} else {
									this.$message.error(res.message || 'Failed!' );
								}
								this.delayLoading = false;
							}
						)
					}
				});
			},
			confirmFreeze() {
				this.$refs.freezeForm.validate((valid) => {
					if (valid) {
						const data = this.freezeForm;
						let params = {
							...this.freezeForm,
							majorProjectId: this.id,
							islhToken : sessionStorage.getItem('islhtoken'),
							eosToken : sessionStorage.getItem('eostoken'),
							expectedResumptionTime: data.expectedResumptionTime ? moment(data.expectedResumptionTime).format('YYYY-MM-DD HH:mm:ss') : '',
							stopWorkTime: data.stopWorkTime ? moment(data.stopWorkTime).format('YYYY-MM-DD HH:mm:ss') : '',
						}
						let url =`${this.$store.state.islhurl}majorProject/frozen`;
						this.freezeLoading = true;
						this._post(url, params).then(
							res => {
								if(res.code === 200) {
									this.$Message.success('Confirm successful!' );
									this.freezeForm = {};
									this.$nextTick(() => {
										this.$refs.freezeForm.clearValidate();
									});
									this.getStatus(3);
								} else {
									this.$message.error(res.message || 'Failed!' );
								}
								this.freezeLoading = false;
							}
						)
					}
				});
			},
			confirmReStart() {
				this.$confirm("Whether to Restart?", "Warning", {
					confirmButtonText: 'Confirm',
					cancelButtonText: 'Cancel',
					type: 'warning'
				}).then(() => {
					let params = {
						majorProjectId: this.id,
						islhToken : sessionStorage.getItem('islhtoken'),
						eosToken : sessionStorage.getItem('eostoken'),
					}
					let url = `${this.$store.state.islhurl}majorProject/restart`
					this._post(url, params).then(
						res =>{
							if(res.code === 200) {
								this.getStatus(4);
								this.$Message.success('Confirm successful!'  )
							} else {
								this.$message.error(res.message || 'Failed!' );
							}
						}
					)
				}).catch(() => {
				});
			},
			confirmKeyPersonnel() {
				this.$refs.keyPersonnelForm.validate((valid) => {
					if (valid) {
						const values = this.keyPersonnelForm;
            let fd = new FormData();
						let params = {
							islhToken: sessionStorage.getItem("islhtoken"),
							eosToken: sessionStorage.getItem("eostoken"),
							majorProjectId: this.id,
							role: values.role,
							memberNoAfterChange: values.memberNoAfterChange,
							memberNameAfterChange: values.memberNameAfterChange,
							reason: values.reason,
							// ...this.keyPersonnelForm,
						}
            // fd.append('file', this.fileList[0].raw);
						if(this.fileList && this.fileList.length > 0) {
							params.handoverSituationFileId = this.fileList[0].fileId;
						}
						fd.append('fileParam', new Blob([JSON.stringify(params)], {type: 'application/json'}))
						let url =`${this.$store.state.islhurl}keyPersonChange/changeKeyPersonnel`;
						this.keyPersonnelLoading = true;
						this._post(url, fd).then(
							res => {
								if(res.code === 200) {
									this.$Message.success('Confirm successful!' );
									this.fileList = [];
									this.keyPersonnelForm = {};
									this.$nextTick(() => {
										this.$refs.keyPersonnelForm.clearValidate();
									});
								} else {
									this.$message.error(res.message || 'Failed!' );
								}
								this.keyPersonnelLoading = false;
							}
						)
					}
				});
			},
		},
  }
</script>
<style lang="less" scoped>
#projectMaintenance {
	.hiddencard {
		height: 0;
		overflow: hidden;
	}
	.el-form {
		padding: 20px 0 20px 0;
		.el-form-item {
			margin-bottom: 10px;
		}
		/deep/.el-form-item__error {
			position: unset;
		}
		/deep/.el-form-item__label {
			line-height: 22px;
			padding: 9px 12px 9px 0px;
		}
		/deep/.el-select {
			width: 100%;
			.el-select__tags {
				max-width: 100%!important;
			}
		}
		/deep/.el-form-item__content .el-input__suffix {
			left: auto;
			right: 10px;
		}
		/deep/.el-range-editor.el-input__inner {
			width: 100%;
		}
		.longlable /deep/.el-form-item__label {
			padding-top: 0;
		}
	}
	.processword {
		color: #f11b1b;
    padding: 0px 0 15px 18px;
	}
}
.el-upload-newlist {
	width: 300px;
	.el-upload-file-box {
		margin-top: 10px;
		border-radius: 4px;
		position: relative;
		line-height: 26px;
		.file-name {
			line-height: 26px;
			color: #606266;
			display: block;
			margin-right: 40px;
			overflow: hidden;
			padding-left: 4px;
			text-overflow: ellipsis;
			-webkit-transition: color .3s;
			transition: color .3s;
			white-space: nowrap;
			i {
				margin-right: 7px;
    		color: #909399;
			}
		}
		.file-name:hover {
			color: #409eff;
		}
		label {
			position: absolute;
			right: 5px;
			top: 0;
			line-height: inherit;
			i {
				line-height: 26px;
			}
			.icon-close {
				cursor: pointer;
			}
			.percentage {
				color: #666;
				font-size: 12px;
			}
		}
	}
	.el-upload-file-box:hover {
		background-color: #f5f7fa;
		.icon-check, .percentage {
			display: none;
		}
		.icon-close {
			display: block !important;
		}
	}
}
</style>


// WEBPACK FOOTER //
// src/view/major/projectMaintenance/index.vue